package com.taager.dukan.feature.home

sealed class HomeViewEvent {
    object Init : HomeViewEvent()
    data class QuickLinkClick(val id: String) : HomeViewEvent()
    object StoreNameClick : HomeViewEvent()
    object SwitchLanguageClick : HomeViewEvent()
    object SwitchColorModeClick : HomeViewEvent()
}
